import { first } from 'underscore';
import {
  orderSources,
  isCameraSource,
  getGroupSources,
  getScreenShareCount,
} from '@shoflo/studio-redux/utils';
import update from 'immutability-helper';
import { withCurrentParams } from '@shoflo/studio-redux/utils';
import { stageFeaturedPresenter } from '@shoflo/studio-redux/actions';
import { CAMERA_PRESENTER, getSourcesSignedUrl } from '@shoflo/polymer';
import { BROADCAST_REORDER_SOURCES } from '@shoflo/studio-redux/actions/types';

const INITIAL_ORDER_POSITION = 1;

function reorderSources(source, dropIndex) {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const {
        broadcastSources: { sources },
      } = getState();

      const groupSources = getGroupSources(sources, source.sourceType);

      // Get sorted sources
      const orderedSources = orderSources(groupSources);
      const dragItemIndex = orderedSources.findIndex(
        (ps) => ps._id === source.id
      );

      const draggedSource = orderedSources[dragItemIndex];
      const screenShareCount = getScreenShareCount(sources);
      const dropPosition = getDropPosition(
        draggedSource,
        dropIndex,
        screenShareCount
      );

      const reorderedSources = update(orderedSources, {
        $splice: [
          [dragItemIndex, 1],
          [dropPosition, 0, draggedSource],
        ],
      }).map((source = {}, index) => {
        return {
          ...source,
          order: index + INITIAL_ORDER_POSITION,
          value: source.value,
        };
      });

      // Make first ordered source featured presenter
      const { _id: presenterId } = first(reorderedSources);
      const isCamera = isCameraSource(source.sourceType);

      const action = {
        type: BROADCAST_REORDER_SOURCES,
        request: async (apiClient) => {
          await apiClient.broadcast.updateSourcesOrder(
            teamId,
            eventId,
            broadcastId,
            {
              sources: reorderedSources,
            }
          );

          return await getSourcesSignedUrl(
            reorderedSources,
            apiClient,
            teamId,
            eventId
          );
        },
        // presenterId and isPresenterSource are required by notifyDirectors
        // middleware
        presenterId,
        isPresenterSource: isCamera,
      };

      dispatch(action);
      // stage as _featured_ after reorder
      if (isCamera) {
        dispatch(stageFeaturedPresenter(presenterId));
      }
    }
  );
}

export default reorderSources;

// helpers
export function getDropPosition(draggedSource, dropIndex, screenShareCount) {
  return draggedSource.type === CAMERA_PRESENTER
    ? dropIndex - screenShareCount
    : dropIndex;
}
